<template>
  <div class="admin-layout">
    <!-- Sidebar -->
    <div class="admin-sidebar" :class="{ collapsed: sidebarCollapsed }">
      <div class="sidebar-header">
        <div class="logo">
          <img src="@/assets/images/logo.png" alt="Logo" v-if="!sidebarCollapsed" />
          <i class="fas fa-shield-alt" v-else></i>
        </div>
        <button @click="toggleSidebar" class="sidebar-toggle">
          <i :class="sidebarCollapsed ? 'fas fa-chevron-right' : 'fas fa-chevron-left'"></i>
        </button>
      </div>

      <nav class="sidebar-nav">
        <ul class="nav-menu">
          <li class="nav-item">
            <router-link to="/admin/dashboard" class="nav-link" active-class="active">
              <i class="fas fa-tachometer-alt"></i>
              <span v-if="!sidebarCollapsed">Dashboard</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/admin/dashboard/concursos" class="nav-link" active-class="active">
              <i class="fas fa-clipboard-list"></i>
              <span v-if="!sidebarCollapsed">Concursos</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/admin/dashboard/candidatos" class="nav-link" active-class="active">
              <i class="fas fa-users"></i>
              <span v-if="!sidebarCollapsed">Candidatos</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/admin/dashboard/inscricoes" class="nav-link" active-class="active">
              <i class="fas fa-file-alt"></i>
              <span v-if="!sidebarCollapsed">Inscrições</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/admin/dashboard/isencoes" class="nav-link" active-class="active">
              <i class="fas fa-percentage"></i>
              <span v-if="!sidebarCollapsed">Isenções</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/admin/dashboard/recursos" class="nav-link" active-class="active">
              <i class="fas fa-gavel"></i>
              <span v-if="!sidebarCollapsed">Recursos</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/admin/dashboard/envios" class="nav-link" active-class="active">
              <i class="fas fa-paper-plane"></i>
              <span v-if="!sidebarCollapsed">Envios</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/admin/dashboard/logs" class="nav-link" active-class="active">
              <i class="fas fa-history"></i>
              <span v-if="!sidebarCollapsed">Logs</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/admin/dashboard/reembolsos" class="nav-link" active-class="active">
              <i class="fas fa-money-bill-wave"></i>
              <span v-if="!sidebarCollapsed">Reembolsos</span>
            </router-link>
          </li>

          <li class="nav-item">
            <router-link to="/admin/dashboard/boletos" class="nav-link" active-class="active">
              <i class="fas fa-barcode"></i>
              <span v-if="!sidebarCollapsed">Boletos</span>
            </router-link>
          </li>

          <li class="nav-item has-submenu">
            <a href="#" class="nav-link" @click.prevent="toggleSubmenu('relatorios')">
              <i class="fas fa-chart-bar"></i>
              <span v-if="!sidebarCollapsed">Relatórios</span>
              <i class="fas fa-chevron-down submenu-arrow" v-if="!sidebarCollapsed"></i>
            </a>
            <ul class="submenu" v-if="!sidebarCollapsed && submenuOpen.relatorios">
              <li class="submenu-item">
                <router-link to="/admin/dashboard/relatorios/concursos" class="submenu-link">
                  <i class="fas fa-clipboard-list"></i>
                  Concursos
                </router-link>
              </li>
              <li class="submenu-item">
                <router-link to="/admin/dashboard/relatorios/candidatos" class="submenu-link">
                  <i class="fas fa-users"></i>
                  Candidatos
                </router-link>
              </li>
              <li class="submenu-item">
                <router-link to="/admin/dashboard/relatorios/financeiro" class="submenu-link">
                  <i class="fas fa-chart-line"></i>
                  Financeiro
                </router-link>
              </li>
            </ul>
          </li>

          <li class="nav-item has-submenu">
            <a href="#" class="nav-link" @click.prevent="toggleSubmenu('configuracoes')">
              <i class="fas fa-cogs"></i>
              <span v-if="!sidebarCollapsed">Configurações</span>
              <i class="fas fa-chevron-down submenu-arrow" v-if="!sidebarCollapsed"></i>
            </a>
            <ul class="submenu" v-if="!sidebarCollapsed && submenuOpen.configuracoes">
              <li class="submenu-item">
                <router-link to="/admin/dashboard/configuracoes/administradores" class="submenu-link">
                  <i class="fas fa-user-shield"></i>
                  Administradores
                </router-link>
              </li>
              <li class="submenu-item">
                <router-link to="/admin/dashboard/configuracoes/sistema" class="submenu-link">
                  <i class="fas fa-cog"></i>
                  Sistema
                </router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </div>

    <!-- Main Content -->
    <div class="admin-main" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
      <!-- Header -->
      <header class="admin-header">
        <div class="header-left">
          <h1 class="page-title">{{ currentPageTitle }}</h1>
        </div>
        <div class="header-right">
          <div class="user-info">
            <div class="user-avatar">
              <i class="fas fa-user-shield"></i>
            </div>
            <div class="user-details">
              <span class="user-name">{{ adminUser.nome || 'Administrador' }}</span>
              <span class="user-role">Administrador</span>
            </div>
          </div>
          <button @click="mostrarModalTrocarSenha" class="btn-change-password">
            <i class="fas fa-key"></i>
            <span>Trocar Senha</span>
          </button>
          <button @click="logout" class="btn-logout">
            <i class="fas fa-sign-out-alt"></i>
            <span>Sair</span>
          </button>
        </div>
      </header>

      <!-- Content -->
      <main class="admin-content">
        <router-view />
      </main>
    </div>

    <!-- Modal Trocar Senha -->
    <div v-if="showModalTrocarSenha" class="modal-overlay" @click.self="fecharModalTrocarSenha">
      <div class="modal-trocar-senha">
        <div class="modal-header">
          <h2>
            <i class="fas fa-key"></i>
            Trocar Senha
          </h2>
          <button @click="fecharModalTrocarSenha" class="btn-close">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="trocarSenha">
            <div class="form-group">
              <label>Senha Atual *</label>
              <div class="input-with-icon">
                <input 
                  v-model="formSenha.senha_atual" 
                  :type="showPasswordAtual ? 'text' : 'password'"
                  class="form-control"
                  placeholder="Digite sua senha atual"
                  required
                />
                <button 
                  type="button" 
                  @click="showPasswordAtual = !showPasswordAtual"
                  class="btn-toggle-password"
                >
                  <i :class="showPasswordAtual ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
            </div>

            <div class="form-group">
              <label>Nova Senha * <small>(mínimo 6 caracteres)</small></label>
              <div class="input-with-icon">
                <input 
                  v-model="formSenha.senha_nova" 
                  :type="showPasswordNova ? 'text' : 'password'"
                  class="form-control"
                  placeholder="Digite a nova senha"
                  minlength="6"
                  required
                />
                <button 
                  type="button" 
                  @click="showPasswordNova = !showPasswordNova"
                  class="btn-toggle-password"
                >
                  <i :class="showPasswordNova ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
            </div>

            <div class="form-group">
              <label>Confirmar Nova Senha *</label>
              <div class="input-with-icon">
                <input 
                  v-model="formSenha.senha_confirmacao" 
                  :type="showPasswordConfirmacao ? 'text' : 'password'"
                  class="form-control"
                  placeholder="Digite a nova senha novamente"
                  minlength="6"
                  required
                />
                <button 
                  type="button" 
                  @click="showPasswordConfirmacao = !showPasswordConfirmacao"
                  class="btn-toggle-password"
                >
                  <i :class="showPasswordConfirmacao ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" @click="fecharModalTrocarSenha" class="btn btn-secondary">
                <i class="fas fa-times"></i>
                Cancelar
              </button>
              <button type="submit" class="btn btn-primary" :disabled="changingPassword">
                <i :class="changingPassword ? 'fas fa-spinner fa-spin' : 'fas fa-check'"></i>
                {{ changingPassword ? 'Alterando...' : 'Alterar Senha' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AdminLayout',
  data() {
    return {
      sidebarCollapsed: false,
      submenuOpen: {
        relatorios: false,
        configuracoes: false
      },
      adminUser: {},
      showModalTrocarSenha: false,
      changingPassword: false,
      showPasswordAtual: false,
      showPasswordNova: false,
      showPasswordConfirmacao: false,
      formSenha: {
        senha_atual: '',
        senha_nova: '',
        senha_confirmacao: ''
      }
    }
  },
  computed: {
    currentPageTitle() {
      return this.$route.meta.title || 'Dashboard'
    }
  },
  mounted() {
    this.loadAdminUser()
    this.checkAuth()
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    },
    toggleSubmenu(submenu) {
      this.submenuOpen[submenu] = !this.submenuOpen[submenu]
    },
    async     loadAdminUser() {
      try {
        const token = localStorage.getItem('admin-token')
        if (token) {
          // Decodificar token JWT para obter dados do usuário
          const payload = JSON.parse(atob(token.split('.')[1]))
          // O token contém os dados em payload.data[0].usuario
          if (payload.data && payload.data[0] && payload.data[0].usuario) {
            this.adminUser = payload.data[0].usuario
          }
        }
      } catch (error) {
        console.error('Erro ao carregar dados do administrador:', error)
        // Se houver erro ao decodificar o token, remover e redirecionar
        localStorage.removeItem('admin-token')
        if (this.$route.path !== '/admin/login') {
          this.$router.push('/admin/login')
        }
      }
    },
    checkAuth() {
      const token = localStorage.getItem('admin-token')
      if (!token) {
        if (this.$route.path !== '/admin/login') {
          this.$router.push('/admin/login')
        }
        return
      }

      // Verificar se o token não expirou
      try {
        const payload = JSON.parse(atob(token.split('.')[1]))
        const now = Math.floor(Date.now() / 1000)
        if (payload.exp < now) {
          localStorage.removeItem('admin-token')
          if (this.$route.path !== '/admin/login') {
            this.$router.push('/admin/login')
          }
        }
      } catch (error) {
        localStorage.removeItem('admin-token')
        if (this.$route.path !== '/admin/login') {
          this.$router.push('/admin/login')
        }
      }
    },
    mostrarModalTrocarSenha() {
      this.showModalTrocarSenha = true
      this.formSenha = {
        senha_atual: '',
        senha_nova: '',
        senha_confirmacao: ''
      }
      this.showPasswordAtual = false
      this.showPasswordNova = false
      this.showPasswordConfirmacao = false
    },
    fecharModalTrocarSenha() {
      this.showModalTrocarSenha = false
      this.formSenha = {
        senha_atual: '',
        senha_nova: '',
        senha_confirmacao: ''
      }
    },
    async trocarSenha() {
      // Validações
      if (this.formSenha.senha_nova !== this.formSenha.senha_confirmacao) {
        this.$sweet.showError('A nova senha e a confirmação não conferem!')
        return
      }

      if (this.formSenha.senha_nova.length < 6) {
        this.$sweet.showError('A nova senha deve ter no mínimo 6 caracteres!')
        return
      }

      if (this.formSenha.senha_atual === this.formSenha.senha_nova) {
        this.$sweet.showError('A nova senha deve ser diferente da senha atual!')
        return
      }

      this.changingPassword = true
      try {
        await axios.put('/ps/admin/trocar-senha', this.formSenha)

        this.$sweet.showSuccess('Senha alterada com sucesso!')
        this.fecharModalTrocarSenha()

      } catch (error) {
        console.error('Erro ao trocar senha:', error)
        const errorMsg = error.response?.data?.error || 'Erro ao trocar senha. Tente novamente.'
        this.$sweet.showError(errorMsg)
      } finally {
        this.changingPassword = false
      }
    },
    async logout() {
      try {
        await axios.post('/ps/admin/logout')
      } catch (error) {
        console.error('Erro ao fazer logout:', error)
      } finally {
        localStorage.removeItem('admin-token')
        // Verificar se já não está na página de login para evitar NavigationDuplicated
        if (this.$route.path !== '/admin/login') {
          this.$router.push('/admin/login')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-layout {
  display: flex;
  min-height: 100vh;
  background: #f8f9fa;
}

/* Sidebar */
.admin-sidebar {
  width: 280px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  transition: width 0.3s ease;
  position: fixed;
  height: 100vh;
  left: 0;
  top: 0;
  z-index: 1000;
  overflow-y: auto;

  &.collapsed {
    width: 70px;
  }
}

.sidebar-header {
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo {
    display: flex;
    align-items: center;
    
    img {
      height: 40px;
      width: auto;
    }
    
    i {
      font-size: 24px;
      color: white;
    }
  }

  .sidebar-toggle {
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: white;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.2);
    }
  }
}

.sidebar-nav {
  padding: 20px 0;

  .nav-menu {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .nav-item {
    margin-bottom: 5px;

    &.has-submenu {
      .nav-link {
        .submenu-arrow {
          margin-left: auto;
          transition: transform 0.3s ease;
        }
      }

      &.open .submenu-arrow {
        transform: rotate(180deg);
      }
    }
  }

  .nav-link {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    transition: all 0.3s ease;
    position: relative;

    i {
      width: 20px;
      margin-right: 12px;
      font-size: 16px;
    }

    &:hover {
      background: rgba(255, 255, 255, 0.1);
      color: white;
    }

    &.active {
      background: rgba(255, 255, 255, 0.2);
      color: white;
      
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background: white;
      }
    }
  }

  .submenu {
    list-style: none;
    margin: 0;
    padding: 0;
    background: rgba(0, 0, 0, 0.1);
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;

    &.open {
      max-height: 200px;
    }

    .submenu-item {
      margin: 0;
    }

    .submenu-link {
      display: flex;
      align-items: center;
      padding: 10px 20px 10px 52px;
      color: rgba(255, 255, 255, 0.7);
      text-decoration: none;
      font-size: 14px;
      transition: all 0.3s ease;

      i {
        width: 16px;
        margin-right: 8px;
        font-size: 14px;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.1);
        color: white;
      }

      &.active {
        background: rgba(255, 255, 255, 0.15);
        color: white;
      }
    }
  }
}

/* Main Content */
.admin-main {
  flex: 1;
  margin-left: 280px;
  transition: margin-left 0.3s ease;

  &.sidebar-collapsed {
    margin-left: 70px;
  }
}

.admin-header {
  background: white;
  padding: 20px 30px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .page-title {
    font-size: 24px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 12px;

    .user-avatar {
      width: 40px;
      height: 40px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 16px;
    }

    .user-details {
      display: flex;
      flex-direction: column;

      .user-name {
        font-weight: 600;
        color: #2c3e50;
        font-size: 14px;
      }

      .user-role {
        font-size: 12px;
        color: #6c757d;
      }
    }
  }

  .btn-change-password {
    background: #667eea;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;

    &:hover {
      background: #5568d3;
    }
  }

  .btn-logout {
    background: #dc3545;
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 14px;

    &:hover {
      background: #c82333;
    }
  }
}

.admin-content {
  padding: 30px;
  min-height: calc(100vh - 80px);
}

/* Modal Trocar Senha */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 20px;
}

.modal-trocar-senha {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 500px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideInDown 0.3s ease;

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 24px;
    border-bottom: 1px solid #e9ecef;

    h2 {
      display: flex;
      align-items: center;
      gap: 10px;
      margin: 0;
      font-size: 1.5rem;
      color: #2c3e50;

      i {
        color: #667eea;
      }
    }

    .btn-close {
      background: none;
      border: none;
      font-size: 1.5rem;
      color: #6c757d;
      cursor: pointer;
      transition: color 0.3s ease;
      width: 35px;
      height: 35px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;

      &:hover {
        color: #dc3545;
        background: rgba(220, 53, 69, 0.1);
      }
    }
  }

  .modal-body {
    padding: 24px;

    form {
      .form-group {
        margin-bottom: 20px;

        label {
          display: block;
          font-weight: 600;
          color: #495057;
          margin-bottom: 8px;
          font-size: 0.95rem;

          small {
            color: #6c757d;
            font-weight: 400;
          }
        }

        .input-with-icon {
          position: relative;
          display: flex;
          align-items: center;

          .form-control {
            width: 100%;
            padding: 12px 45px 12px 12px;
            border: 1px solid #ced4da;
            border-radius: 8px;
            font-size: 0.95rem;
            transition: border-color 0.3s ease, box-shadow 0.3s ease;

            &:focus {
              outline: none;
              border-color: #667eea;
              box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
            }
          }

          .btn-toggle-password {
            position: absolute;
            right: 10px;
            background: none;
            border: none;
            color: #6c757d;
            cursor: pointer;
            padding: 5px 10px;
            transition: color 0.3s ease;

            &:hover {
              color: #667eea;
            }
          }
        }
      }

      .modal-footer {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
        margin-top: 24px;
        padding-top: 20px;
        border-top: 1px solid #e9ecef;

        .btn {
          padding: 10px 20px;
          border: none;
          border-radius: 8px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 0.95rem;

          &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
          }

          &.btn-secondary {
            background: #6c757d;
            color: white;

            &:hover:not(:disabled) {
              background: #5a6268;
            }
          }

          &.btn-primary {
            background: #667eea;
            color: white;

            &:hover:not(:disabled) {
              background: #5568d3;
            }
          }
        }
      }
    }
  }
}

@keyframes slideInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsividade */
@media (max-width: 768px) {
  .admin-sidebar {
    transform: translateX(-100%);
    
    &.open {
      transform: translateX(0);
    }
  }

  .admin-main {
    margin-left: 0;
  }

  .admin-header {
    padding: 15px 20px;

    .page-title {
      font-size: 20px;
    }

    .user-details {
      display: none;
    }

    .btn-change-password span,
    .btn-logout span {
      display: none;
    }

    .btn-change-password,
    .btn-logout {
      padding: 8px 12px;
    }
  }

  .admin-content {
    padding: 20px;
  }

  .modal-trocar-senha {
    max-width: 95%;
  }
}
</style>
